<template>
  <main class="exam-warning">
    <section class="exam-warning__content">
      <div class="exam-warning__icon-wrapper">
        <div class="exam-warning__circle">
          <FileTextSvg />
        </div>
        <div class="exam-warning__info">
          <InfoWarningCircle />
        </div>
      </div>

      <p class="exam-warning__message" v-if="showLabel">
        Não identifiquei exames no arquivo enviado
      </p>
    </section>

    <section class="bottomContainer">
      <button class="button" @click="$emit('review-orders')">Revisar pedidos enviados</button>
      <button class="button button--secondary" @click="$emit('secondary-action')">
        Continuar sem pedido médico
      </button>
    </section>
  </main>
</template>

<script>
import FileTextSvg from '@/assets/img/icons/file-text-component.svg?inline';
import InfoWarningCircle from '@/assets/img/icons/info-warning-circle.svg?inline';

export default {
  components: {
    FileTextSvg,
    InfoWarningCircle,
  },
  props: {
    showLabel: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.exam-warning {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0;

  &__content {
    flex: 1;
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__icon-wrapper {
    position: relative;
    display: inline-block;
  }

  &__circle {
    background-color: #fef1e6;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    svg path {
      fill: #d26404;
    }
  }

  &__info {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__message {
    font-family: 'Dasa sans', sans-serif;
    font-weight: var(--font-weight-bold);
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #161616b8;
    margin-top: 16px;
  }
  .button {
    font-family: 'Dasa sans', sans-serif;
    font-size: 16px;
    font-weight: var(--font-weight-bold);
    line-height: 24px;
    text-align: center;
    width: 100%;
    padding: 12px 0px;
    border: 1px solid var(--color-button-primary);
    border-radius: 4px;
    background: var(--color-button-primary);
    margin: 0 0 8px 0;
    color: white;
    cursor: pointer;

    &--secondary {
      margin: 0;
      background: white;
      color: var(--color-button-primary);

      & svg {
        vertical-align: middle;
        margin-left: 10px;

        path {
          fill: var(--color-primary);
        }
      }
    }

    &:disabled {
      cursor: not-allowed;
      background-color: var(--color-grey-1);
      border-color: var(--color-grey-5);
      color: var(--color-grey-5);
    }
  }
}
</style>
